<template>
  <v-card max-width="100%" height="100%" flat class="card pa-2" :color="color" dark>
    
    <div class="text-center caption px-2">
      <sub> {{ quantity }} pedidos </sub><br />
      {{ title }}
    </div>
    <div class="text-center">
      <h2>{{ format }}</h2>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'DashboardCard2',
  props: {title: String, quantity: Number, value: Number, color: String},
  computed: {
    cssVars() {
      return {'--border-color': this.color, '--icon-color': this.color}
    },
    format() {
      let number = this.value
      let r = number
      if (number < 100000) {
        r = `R$ ${(number / 10000).toFixed(2).replace('.', ',')}`
      }
      if (number >= 100000 && number < 99999999) {
        r = `R$ ${(number / 100000).toFixed(2).replace('.', ',')} K`
      }
      if (number >= 99999999) {
        r = `R$ ${(number / 10000000).toFixed(2).replace('.', ',')} M`
      }
      return r
    },
  },
  data: () => ({}),
}
</script>

<style scoped>
.card {
  border: 4px solid var(--border-color) !important;
  margin: auto;
}
.cardIcon {
  color: var(--icon-color) !important;
  margin-right: 10px;
}
</style>
